export default __webpack_public_path__ + "static/media/thum5.31f46908.jpg";